(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["comparador"] && !Shopify.designMode) return;
  try {
    (function(){
var CATS=['Patinetas','Mopeds','Bicicletas'];
var ROWS=[['Precio','price'],['Autonomía','aut'],['Suspensión','sus'],['Tensión / capacidad','bat'],['Tiempo de carga','carga'],['Peso neto','peso']];
function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
function name(t){return String(t).replace(/\u200e/g,'').replace(/^(scooter|moped|bicicleta)\s+el[eé]ctric[oa]\s+/i,'').replace(/^minca\s+(?=ats)/i,'').replace(/(\d+)w\b/i,'$1W').trim();}
function init(root){
if(root.getAttribute('data-mc-ready'))return;root.setAttribute('data-mc-ready','1');
var data;try{data=JSON.parse(root.querySelector('[data-mc-data]').textContent);}catch(e){return;}
var cur=root.getAttribute('data-current'),by={};data.forEach(function(d){by[d.h]=d;});
var cj=null;try{cj=JSON.parse(root.querySelector('[data-mc-cur]').textContent);}catch(e){}
if(cj&&cj.h){cj.cat=(by[cj.base]||{}).cat||'Patinetas';by[cj.h]=cj;}
var L=by[cur];if(!L)return;
var opts=data.filter(function(d){return d.h!==cur;}).sort(function(a,b){return a.p-b.p;});
if(!opts.length){root.hidden=true;return;}
function pick(){var r=by[L.cmp];if(r&&r.h!==cur)return r.h;var av=opts.filter(function(d){return d.av;});if(!av.length)av=opts;var pool=av.filter(function(d){return d.cat===L.cat;});if(!pool.length)pool=av;var best=pool[0],bd=Infinity;pool.forEach(function(d){var x=Math.abs(d.p-L.p);if(x<bd){bd=x;best=d;}});return best.h;}
var right=pick();
function val(d,k){
if(k==='price')return(d.c>d.p?'<s class="mc-cmp__old">'+esc(d.cf)+'</s>':'')+'<span class="mc-cmp__new">'+esc(d.pf)+'</span>';
var v=d[k];if(!v)return'<span class="mc-cmp__pc">Por confirmar</span>';
return k==='aut'?'hasta '+esc(v):esc(v);}
function pic(d){return d.img?'<img class="mc-cmp__img" src="'+esc(d.img)+'" alt="'+esc(name(d.t))+'" width="140" height="96" loading="lazy">':'';}
function head(d){return esc(name(d.t))+(d.pre?' <span class="mc-cmp__tag">Preventa</span>':'')+(d.av?'':' <span class="mc-cmp__tag mc-cmp__tag--off">Agotada</span>');}
var box=root.querySelector('[data-mc-table]');
function render(){
var R=by[right];
var sel='<select class="mc-cmp__sel" aria-label="Elegir vehículo para comparar">'+CATS.map(function(c){var ks=opts.filter(function(d){return d.cat===c;});if(!ks.length)return'';return'<optgroup label="'+c+'">'+ks.map(function(d){return'<option value="'+esc(d.h)+'"'+(d.h===right?' selected':'')+'>'+esc(name(d.t).replace(/^ATS\s+/i,''))+(d.pre?' · Preventa':'')+(d.av?'':' · Agotada')+'</option>';}).join('')+'</optgroup>';}).join('')+'</select>';
var h='<div class="mc-cmp__hd mc-cmp__blank"></div><div class="mc-cmp__hd">'+pic(L)+'<small>Estás viendo</small><span>'+head(L)+'</span></div><div class="mc-cmp__hd">'+pic(R)+'<small>Comparar con</small>'+sel+'</div>';
ROWS.forEach(function(r,i){var z=i%2===0?' mc-cmp__odd':'';h+='<div class="mc-cmp__lbl'+z+'">'+r[0]+'</div><div class="'+z+'">'+val(L,r[1])+'</div><div class="'+z+'">'+val(R,r[1])+'</div>';});
h+='<div class="mc-cmp__blank"></div><div></div><div><a class="mc-cmp__see" href="'+esc(R.u)+'">Ver '+esc(name(R.t))+'</a></div>';
box.innerHTML=h;
var s=box.querySelector('select');s.addEventListener('change',function(e){right=e.target.value;render();box.querySelector('select').focus();});}
render();
fitBtn(root);}
function fitBtn(root){var b=root.querySelector('.mc-cmp__btn');var sc=root.closest('form,section,product-info,.shopify-section')||document;var cart=sc.querySelector('button[name="add"],[type="submit"][name="add"]')||document.querySelector('form[action*="/cart/add"] button[type="submit"]');function f(){if(!cart||!cart.offsetWidth){b.style.maxWidth='';return;}b.style.maxWidth=cart.offsetWidth+'px';}f();window.addEventListener('resize',f);}
function all(){var n=document.querySelectorAll('.mc-cmp');for(var i=0;i<n.length;i++)init(n[i]);}
if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',all);
document.addEventListener('shopify:section:load',all);
})();
  } catch(e) { console.error(e); }
})();

})();
